import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function replaceResponse(_this__u8e3s4, headers, content) {
  headers = headers === VOID ? _this__u8e3s4.t5h().n51() : headers;
  return DelegatedCall().m5j(_this__u8e3s4.o5h_1, _this__u8e3s4, content, headers);
}
var DelegatedCallClass;
function DelegatedCall() {
  if (DelegatedCallClass === VOID) {
    class $ extends HttpClientCall() {
      static m5j(client, originCall, responseContent, responseHeaders) {
        responseHeaders = responseHeaders === VOID ? originCall.t5h().n51() : responseHeaders;
        var $this = this.n5j(client);
        $this.q5h_1 = new (DelegatedRequest())($this, originCall.o5j());
        $this.r5h_1 = new (DelegatedResponse())($this, originCall.t5h(), responseContent, responseHeaders);
        return $this;
      }
    }
    initMetadataForClass($, 'DelegatedCall', VOID, VOID, VOID, [0, 1]);
    DelegatedCallClass = $;
  }
  return DelegatedCallClass;
}
var DelegatedRequestClass;
function DelegatedRequest() {
  if (DelegatedRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.t5j_1 = origin;
        this.u5j_1 = call;
      }
      v5j() {
        return this.u5j_1;
      }
      sv() {
        return this.t5j_1.sv();
      }
      w5j() {
        return this.t5j_1.w5j();
      }
      x5j() {
        return this.t5j_1.x5j();
      }
      p5j() {
        return this.t5j_1.p5j();
      }
      h2o() {
        return this.t5j_1.h2o();
      }
      n51() {
        return this.t5j_1.n51();
      }
    }
    initMetadataForClass($, 'DelegatedRequest', VOID, VOID, [HttpRequest()]);
    DelegatedRequestClass = $;
  }
  return DelegatedRequestClass;
}
var DelegatedResponseClass;
function DelegatedResponse() {
  if (DelegatedResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, origin, content, headers) {
        headers = headers === VOID ? origin.n51() : headers;
        super();
        this.y5j_1 = call;
        this.z5j_1 = origin;
        this.a5k_1 = content;
        this.b5k_1 = headers;
        this.c5k_1 = this.z5j_1.sv();
      }
      v5j() {
        return this.y5j_1;
      }
      n51() {
        return this.b5k_1;
      }
      d5k() {
        return this.a5k_1(this.z5j_1);
      }
      sv() {
        return this.c5k_1;
      }
      e5k() {
        return this.z5j_1.e5k();
      }
      f5k() {
        return this.z5j_1.f5k();
      }
      g5k() {
        return this.z5j_1.g5k();
      }
      h5k() {
        return this.z5j_1.h5k();
      }
    }
    initMetadataForClass($, 'DelegatedResponse');
    DelegatedResponseClass = $;
  }
  return DelegatedResponseClass;
}
//region block: exports
export {
  replaceResponse as replaceResponse3ut5eo3odxj99,
};
//endregion

//# sourceMappingURL=DelegatedCall.mjs.map
